function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_38",
  "data-name": "Group 38",
  transform: "translate(0.375 0.375)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_25",
  "data-name": "Path 25",
  d: "M1487.708,1580.059a.852.852,0,0,0-.864-.838h-5.979a.852.852,0,0,0-.864.838V1591.9a.852.852,0,0,0,.864.838h5.979a.852.852,0,0,0,.864-.838v-11.838",
  transform: "translate(-1480 -1579.221)",
  fill: "none",
  stroke: "#b9bbcb",
  strokeMiterlimit: 10,
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_23",
  "data-name": "Line 23",
  x1: 7.708,
  transform: "translate(0 10.471)",
  fill: "none",
  stroke: "#b9bbcb",
  strokeLinejoin: "round",
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_26",
  "data-name": "Path 26",
  d: "M1529.966,1741.12a.222.222,0,1,0,.222-.214A.218.218,0,0,0,1529.966,1741.12Z",
  transform: "translate(-1526.333 -1729.152)",
  fill: "none",
  stroke: "#b9bbcb",
  strokeLinejoin: "round",
  strokeWidth: 0.75
}));

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8.458,
    height: 14.264,
    viewBox: "0 0 8.458 14.264",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.1a3243a3.svg";
export { ForwardRef as ReactComponent };